import { render, staticRenderFns } from "./offline_order_batch_detail.vue?vue&type=template&id=02de87bc&scoped=true"
import script from "./offline_order_batch_detail.vue?vue&type=script&lang=js"
export * from "./offline_order_batch_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02de87bc",
  null
  
)

export default component.exports